import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "nav-datepicker nav-item" };
const _hoisted_2 = { class: "nav-datepicker nav-item" };
const _hoisted_3 = { class: "nav-datepicker nav-item" };
const _hoisted_4 = {
    key: 0,
    class: "disabled"
};
const _hoisted_5 = { class: "text" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "text" };
import { includeDateRoutes, exceptionallyIncludeDateRoutes, showDatepickerWithOtherRules, showDatepickerWithCurrentAndFowardDatesDisabled, showTwelveMonthsPlusCurrentShortcut, } from '@/helpers/menu';
import { datepickerLanguage, datepickerUpdate } from '@/helpers/setup-datepicker';
import { disabledForwardDates } from '@/utilities/datepicker';
import { useStore } from 'vuex';
import { h, shallowRef, computed, watch, ref } from 'vue';
import { useMixpanelConfig, useMixpanelDatepicker, useMixpanelDatepickerPanelLinks } from '@/utilities/mixpanel';
import moment from 'moment';
import { dateFormat } from '@/utilities/constants';
import router from '@/router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeaderDatepicker',
    props: {
        language: {},
        route: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const customPrefix = shallowRef({
            render() {
                return h('i', {
                    class: 'icon icon-calendar-30px',
                });
            },
        });
        const datepickerDates = ref(null);
        const datepickerStartDate = ref('');
        const datepickerEndDate = ref('');
        const NAME_EVENT_MIXPANEL = `_${String(router.currentRoute.value.name)}`;
        const isBrandRefreshActive = computed(() => store.getters['base/getSelectedBrandStatus']);
        const getDates = computed(() => store.getters['dates']);
        const setUpdateSelectedBrand = (boolean) => store.dispatch('base/updateSelectedBrand', boolean);
        const showDatePicker = computed(() => {
            if (props.route === '/')
                return false;
            if (exceptionallyIncludeDateRoutes.some(el => props.route === el))
                return true;
            return includeDateRoutes.some(el => props.route?.includes(el));
        });
        const getShortcuts = computed(() => {
            let shortcuts = datepickerLanguage(props.language).el.shortcuts;
            if (!showTwelveMonthsPlusCurrentShortcut.some(el => props.route?.includes(el))) {
                shortcuts = shortcuts.filter(shortcuts => shortcuts.key !== 'twelveMonthsPlusCurrent');
            }
            const result = shortcuts.map(item => ({
                text: item.text,
                value() {
                    const dates = {
                        startDate: item.value[0]['_d'],
                        endDate: item.value[1]['_d'],
                    };
                    useMixpanelDatepickerPanelLinks(`view${NAME_EVENT_MIXPANEL}_click_link_sidebar_datepicker`, item.text, dates);
                    return item.value;
                },
            }));
            return result;
        });
        const datepickerValue = computed({
            get() {
                const dates = {
                    startDate: getDates?.value?.startDate,
                    endDate: getDates?.value?.endDate,
                };
                return [dates.startDate, dates.endDate];
            },
            set(newDate) {
                useMixpanelDatepicker(`view${NAME_EVENT_MIXPANEL}_select_datepicker`, newDate[0], newDate[1]);
                datepickerUpdate(newDate);
            },
        });
        const openMixPanel = () => {
            useMixpanelConfig(`view${NAME_EVENT_MIXPANEL}_open_datepicker`);
        };
        const showDatepickerWithDisabledCurrentAndForwardDates = computed(() => {
            return showDatepickerWithCurrentAndFowardDatesDisabled.some(el => props.route?.includes(el));
        });
        // functions for datepicker different disabled dates rules
        const showDatepickerDiferentRules = computed(() => {
            return showDatepickerWithOtherRules.some(el => props.route?.includes(el));
        });
        const disabledDatesOtherRules = (time) => {
            datepickerDates.value = time;
            const firstDateSelected = datepickerStartDate.value;
            const currentDate = moment().format(dateFormat);
            if (!firstDateSelected)
                return time.getTime() > Date.now();
            if (firstDateSelected === currentDate)
                return time.getTime() < moment().subtract(1, 'days').valueOf() || time.getTime() > Date.now();
            else if (moment(firstDateSelected).isBefore(currentDate))
                return time.getTime() >= moment().subtract(1, 'days').valueOf();
        };
        const calendarWatch = (date) => {
            datepickerStartDate.value = moment(date[0]).format(dateFormat);
            if (date[1] !== null) {
                datepickerEndDate.value = moment(date[1]).format(dateFormat);
            }
        };
        const disableFutureDatesAndOutOfYearRange = (time) => {
            datepickerDates.value = time;
            const firstDateSelected = datepickerStartDate.value;
            const secondDateSelected = datepickerEndDate.value;
            const currentTime = time.getTime();
            const futureLimit = moment().subtract(1, 'days');
            const pastDateRangeLimit = moment(firstDateSelected).subtract(1, 'year').subtract(31, 'days');
            const futureDateRangeLimit = moment(firstDateSelected).add(1, 'year').add(31, 'days');
            if (firstDateSelected && !secondDateSelected)
                return (currentTime >= futureLimit.valueOf() ||
                    currentTime <= pastDateRangeLimit.valueOf() ||
                    currentTime >= futureDateRangeLimit.valueOf());
            return currentTime >= futureLimit.valueOf();
        };
        const clearStartDate = () => {
            if (datepickerEndDate.value) {
                datepickerStartDate.value = '';
                datepickerEndDate.value = '';
            }
            datepickerEndDate.value = '';
        };
        watch(isBrandRefreshActive, status => {
            if (status) {
                setUpdateSelectedBrand(false);
            }
        });
        return (_ctx, _cache) => {
            const _component_el_date_picker = _resolveComponent("el-date-picker");
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_el_date_picker, {
                        modelValue: datepickerValue.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((datepickerValue).value = $event)),
                        type: "daterange",
                        format: "DD/MM/YYYY",
                        "value-format": "YYYY-MM-DD",
                        clearable: false,
                        shortcuts: getShortcuts.value,
                        editable: true,
                        "disabled-date": _unref(disabledForwardDates),
                        "prefix-icon": customPrefix.value,
                        onFocus: openMixPanel
                    }, null, 8, ["modelValue", "shortcuts", "disabled-date", "prefix-icon"])
                ], 512), [
                    [_vShow, showDatePicker.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_date_picker, {
                        modelValue: datepickerValue.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((datepickerValue).value = $event)),
                        type: "daterange",
                        format: "DD/MM/YYYY",
                        "value-format": "YYYY-MM-DD",
                        clearable: false,
                        shortcuts: getShortcuts.value,
                        editable: true,
                        "disabled-date": disabledDatesOtherRules,
                        "prefix-icon": customPrefix.value,
                        onFocus: openMixPanel,
                        onCalendarChange: calendarWatch,
                        onVisibleChange: clearStartDate
                    }, null, 8, ["modelValue", "shortcuts", "prefix-icon"])
                ], 512), [
                    [_vShow, showDatepickerDiferentRules.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_date_picker, {
                        "popper-class": "custom-datepicker",
                        modelValue: datepickerValue.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((datepickerValue).value = $event)),
                        type: "daterange",
                        format: "DD/MM/YYYY",
                        "value-format": "YYYY-MM-DD",
                        clearable: false,
                        shortcuts: getShortcuts.value,
                        editable: true,
                        "disabled-date": disableFutureDatesAndOutOfYearRange,
                        "prefix-icon": customPrefix.value,
                        onFocus: openMixPanel,
                        onCalendarChange: calendarWatch,
                        onVisibleChange: clearStartDate
                    }, {
                        default: _withCtx((cell) => [
                            (disableFutureDatesAndOutOfYearRange(cell?.date))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "top",
                                        width: 170
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(cell.text), 1)
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('datepicker-disabled-dates-tooltip')), 1)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(cell.text), 1)
                                ]))
                        ]),
                        _: 1
                    }, 8, ["modelValue", "shortcuts", "prefix-icon"])
                ], 512), [
                    [_vShow, showDatepickerWithDisabledCurrentAndForwardDates.value]
                ])
            ], 64));
        };
    }
});
